import styled, { css } from 'styled-components';

export const StyledHead = styled.div<{
  transparent?: boolean;
  divider?: boolean;
  background?: string;
  color?: string;
  sticky?: boolean;
  height?: number;
  displayMode?: 'flex' | 'table';
}>`
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  text-align: center;

  ${({ height }) => height && css`
    height: ${height}px;
  `}

  ${({ displayMode }) => displayMode === 'table' && css`
    display: table-row-group;
  `}

  ${({ sticky }) => sticky && css`
    position: relative;
    top: 0;
    z-index: 1;
  `}

  ${({ divider, theme }) => divider && css`
    border-bottom: 1px solid ${theme.colors.black};
  `}
`;
